import { SimpleSelect } from 'lib/ui';

export const MultiSelect = ({ input, data }) => {
  return <SimpleSelect multiple {...input} {...data} />;
};
